﻿(function () {
    'use strict';

    var controllerId = 'stockSummary';

    angular.module('app.controllers').controller(controllerId, stockSummary)

    stockSummary.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams', '$translate'];

    function stockSummary(common, datacontext, $http, $scope, $stateParams, $translate) {
        let vm = this;

        vm.carrierId = 0;
        vm.carrierName = "";
        vm.carrierFilterDisabled = false;

        vm.equipmentData = [];

        function init() {
            common.activateController().then(function (data) { });
            vm.initializeData();
            vm.clearCriteria();
            vm.setBasicInformation();
            vm.getGeneralFilters();
            vm.getCarriers();
            vm.clearReport();
        }

        vm.initializeData = function () {
            vm.equipmentData = [];
            vm.equipmentsDataSource = new kendo.data.DataSource({
                data: vm.equipmentData
            });

            vm.gridOptions = {
                dataSource: vm.equipmentsDataSource,
                sortable: false,
                pageable: false,
                groupable: false,
                columns: [
                    {
                        title: " ",
                        field: "DUMMY",
                        width: "12%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.DUMMY)#',
                        attributes: {
                            "style": " text-align: center;"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "OPE",
                        field: "OPE",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.OPE)#',
                        attributes: {
                            "style": " text-align: center;background-color:\\#E1E1E1;"
                        },
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "DA",
                        field: "DA",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.DA)#',
                        attributes: {
                            "style": " text-align: center;background-color:\\#E1E1E1;"
                        },
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "DA BOX/MAQ",
                        field: "DABOXMAQ",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.DABOXMAQ)#',
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "DA BOX ",
                        field: "DABOX",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.DABOX)#',
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "DA MAQ/INT",
                        field: "DAMAQINT",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.DAMAQINT)#',
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "SC",
                        field: "SC",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.SC)#',
                        attributes: {
                            "style": " text-align: center;background-color:\\#E1E1E1;"
                        },
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "SC BOX/PTI",
                        field: "SCBOXPTI",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.SCBOXPTI)#',
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "SC BOX",
                        field: "SCBOX",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.SCBOX)#',
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "SC PTI/INT",
                        field: "SCPTIINT",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.SCPTIINT)#',
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    },
                    {
                        title: "TOTAL",
                        field: "TOTAL",
                        width: "10%",
                        template: '#=formatResultsCell(data.DUMMY,data.CLASSId,data.TOTAL)#',
                        attributes: {
                            "style": " text-align: center; background-color:\\#E1E1E1;"
                        },
                        headerAttributes: {
                            "style": "text-align:center;",
                            class: "cellInBold"
                        }
                    }
                ]
            };
        }
        vm.fnSetDefaultDepot = function() {
            var authData = common.localStorageService.get('authorizationData');
            if (authData) {
                var currentYardId = authData.ModelRequester.CurrentYardId;
                if (currentYardId !== undefined)
                    vm.criteria.depotId = Number(currentYardId);
            }
        }

        vm.setBasicInformation = function () {
            var authData = common.localStorageService.get('authorizationData');
            vm.roleSelected = authData ? authData.userRole : "";
            vm.isAdmin = vm.roleSelected === "COPAdminP" ? true : false;

            var associateCarrier = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');

            if (associateCarrier && associateCarrier.Name) {
                vm.carrierId = associateCarrier.BusinessPartnerId;
                vm.carrierName = associateCarrier.Name;
            }
        }

        vm.initializeDepot = function () {
            vm.listDepots = [];
        };

        vm.getGeneralFilters = function () {
            vm.initializeDepot();
            return datacontext.stocksummary.getFilters(vm.roleSelected).then(function (data) {
                if (data) {
                    if (data.Depot != null && data.Depot.length > 0) {
                        vm.listDepots = data.Depot;
                        vm.criteria.depotId = vm.listDepots[0].Id;
                        vm.fnSetDefaultDepot();

                    }
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.initializeCarrier = function () {
            vm.listCarriers = [{Name:"", Id:null}];
        };

        vm.getCarriers = function () {
            vm.initializeCarrier();
            return datacontext.stocksummary.getCarrierList().then(function (data) {
                if (data) {
                    angular.forEach(data, function (value, key) {
                        vm.listCarriers.push(value);
                    });

                    vm.updateCarrierFilter();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.updateCarrierFilter = function () {
            if (vm.listCarriers && vm.carrierId !== 0) {
                vm.listCarriers.forEach(function (value, key) {
                    if (value.Id == vm.carrierId) {
                        vm.criteria.carrierId = value.Id;
                        vm.carrierFilterDisabled = true;
                    }
                });
            }
            else {
                vm.carrierFilterDisabled = false;
            }
        }

        vm.clearReport = function () {
            vm.equipmentData = []
            vm.equipmentsDataSource = { data: vm.equipmentData };
            vm.clearCriteria();
            vm.refresReport();
        };

        vm.clearCriteria = function () {
            vm.criteria = {
                depotId: vm.listDepots ? (vm.listDepots.length > 0 ? vm.listDepots[0].Id : 0) : 0,
                carrierId: vm.listCarriers ? (vm.listCarriers.length > 0 ? vm.listCarriers[0].Id : 0) : 0
            };

            vm.refresReport();
        }

        vm.searchReport = function () {
            var criteria = {
                YardId: vm.criteria.depotId,
                CarrierId: vm.criteria.carrierId
            };

            datacontext.stocksummary.getstockSummaryList(criteria).then(function (data) {
                if (data) {
                    vm.equipmentData = data;
                    vm.equipmentsDataSource = { data: vm.equipmentData };
                    vm.refresReport();
                }
                else {
                    vm.clearReport();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.exportReport = function () {
            if (vm.equipmentData.length == 0) {
                toastr.info($translate.instant('views.stocksummary.noDataToExport'));
                return;
            }

            var criteria = {
                YardId: vm.criteria.depotId,
                CarrierId: vm.criteria.carrierId
            };

            datacontext.stocksummary.getstockSummaryListExcel(criteria, "Resumen Stock");
        };

        vm.refresReport = function () {
            var mainReport = angular.element('#mainReport').data("kendo-grid");

            if (mainReport) {
                mainReport.refresh();
            }
        }

        init();

        window.formatResultsCell = function (DUMMY, CLASSId, value) {
            
            var title = DUMMY ? DUMMY : "";
            if (DUMMY.match("TOTAL")) //== "TOTAL DRY" || DUMMY == "TOTAL GEN" || DUMMY == "TOTAL REF" || DUMMY == "TOTAL FLB" || DUMMY == "TOTAL CHS" || DUMMY == "TOTAL PRA" ||  DUMMY == "TOTAL TAN" || DUMMY == "TOTAL STOCK")
            return "<div style='background-color:#E1E1E1; border: 1px solid; #E1E1E1'font-size:14px><font color='blue'><strong>" + value + "<strong></font></div>";
            if (CLASSId == 0 || title.indexOf("TOTAL") != -1)
                return "<div style='font-weight: bold; font-size:14px'><font color='blue'><strong>" + value + "<strong></font></div>";
           
            else
                return  value;
        };
    }

})();
